var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "task-sub" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "clickoutside",
            rawName: "v-clickoutside",
            value: _vm.subtasksSubmit,
            expression: "subtasksSubmit",
          },
        ],
        staticClass: "subtasks-content",
      },
      [
        _c(
          "div",
          { staticClass: "checkbox-box subtasks-box" },
          [
            _c("el-checkbox", {
              attrs: { disabled: _vm.checkDisabled },
              model: {
                value: _vm.checked,
                callback: function ($$v) {
                  _vm.checked = $$v
                },
                expression: "checked",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "subtasks-content-box" },
          [
            _c("el-input", {
              attrs: {
                maxlength: 50,
                type: "textarea",
                autosize: "",
                placeholder: "请输入内容",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.subtasksSubmit.apply(null, arguments)
                },
              },
              model: {
                value: _vm.subtasksTextarea,
                callback: function ($$v) {
                  _vm.subtasksTextarea = $$v
                },
                expression: "subtasksTextarea",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "flexbox",
          { staticClass: "subtasks-content-png" },
          [
            _c(
              "div",
              { staticClass: "time" },
              [
                _c("el-date-picker", {
                  ref: "subtasksDate",
                  style: { width: _vm.subtasksDate ? "54px" : "28px" },
                  attrs: {
                    type: "date",
                    format: "yyyy 年 MM 月 dd 日",
                    "value-format": "yyyy-MM-dd",
                    placeholder: "选择日期",
                  },
                  model: {
                    value: _vm.subtasksDate,
                    callback: function ($$v) {
                      _vm.subtasksDate = $$v
                    },
                    expression: "subtasksDate",
                  },
                }),
                _vm._v(" "),
                _vm.subtasksDate
                  ? _c("span", { staticClass: "bg-color" }, [
                      _vm._v(
                        _vm._s(_vm._f("moment")(_vm.subtasksDate, "YYYY-MM-DD"))
                      ),
                    ])
                  : _c("i", {
                      staticClass: "wukong wukong-time-task",
                      on: { click: _vm.subtasksDateFun },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-popover",
              {
                attrs: {
                  placement: "bottom-end",
                  width: "280",
                  "popper-class": "no-padding-popover",
                  trigger: "click",
                },
                model: {
                  value: _vm.showUserPopover,
                  callback: function ($$v) {
                    _vm.showUserPopover = $$v
                  },
                  expression: "showUserPopover",
                },
              },
              [
                _c("xh-user", {
                  ref: "xhuser",
                  attrs: {
                    "info-request": _vm.ownerListRequest,
                    "info-params": _vm.ownerListParams,
                    "selected-data": _vm.xhUserData,
                    radio: "",
                  },
                  on: { changeCheckout: _vm.xhUserCheckout },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "select-box",
                    attrs: { slot: "reference" },
                    slot: "reference",
                  },
                  [
                    _vm.xhUserData && _vm.xhUserData.length
                      ? _vm._l(_vm.xhUserData, function (item, index) {
                          return _c(
                            "span",
                            { key: index },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    placement: "bottom",
                                    effect: "light",
                                    "popper-class": "tooltip-change-border",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function ($event) {
                                              _vm.showUserPopover = true
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.realname))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("xr-avatar", {
                                    attrs: {
                                      name: item.realname,
                                      size: 24,
                                      src: item.img || item.thumb_img,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        })
                      : _c("i", { staticClass: "wukong wukong-user" }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }